import produce from 'immer';

import { useOAIOptimisticMutation, useOAIQuery } from '~/hooks/reactQuery';
import type { OAISchema } from '~/types/openapi';

export const useRecentSearchKeywords = () => {
  return useOAIQuery({
    queryKey: '/api/market-place/v1/recently/search-keywords',
    queryOptions: {
      keepPreviousData: true,
    },
  });
};

export const useDeleteSearchKeywords = () => {
  const mutate = useOAIOptimisticMutation({
    method: 'put',
    mutationKey: '/api/market-place/v1/recently/delete-keywords',
    updateQueryKey: '/api/market-place/v1/recently/search-keywords',
    invalidateQueryKeys: ['/api/market-place/v1/recently/search-keywords'],
    updater: ({
      old,
      variables: {
        requestBody: { keywords },
      },
    }) => {
      return produce(old, (current) => {
        const newKeyworkds = [] as OAISchema['RecentlySearchKeywordResponse'][];

        current.forEach((item) => {
          if (!keywords.includes(item.keyword)) {
            newKeyworkds.push(item);
          }
        });

        return newKeyworkds;
      });
    },
  });

  return mutate;
};
